<template>
    <div>
        <Header backButton></Header>
        <div class="inscription">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <form method="post" @submit="send" class="indexUp">
                <div class="contenu pt-12">
                    <p class="text-5xl mb-10 leading-tight">
                        Connexion sur
                        <span class="sunshiney">Quest Me</span> !
                    </p>
                    <p class="text-2xl mb-10 leading-tight">Content de vous revoir ✌️ !</p>
                    <p class="text-2xl leading-tight">Login</p>
                    <input class="my-5" v-model="email" name="email" type="text" required>
                    <p class="text-2xl leading-tight">Password</p>
                    <input class="my-5" v-model="password" name="password" type="password" required>
                </div>
                <div class="groupBouton mt-20">
                    <SubmitRound text="Connexion" white></SubmitRound>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Bouton from "@/components/boutons/Bouton.vue";
import SubmitRound from "@/components/inputs/SubmitRound.vue";

export default {
    name: "inscription",
    components: {
        Bouton,
        Header,
        SubmitRound
    },
    data() {
        return {
            email: "",
            password: "",
            error: null
        };
    },
    computed: {
        user: {
            get() {
                return this.$store.getters.currentAppUserData;
            },
            set(value) {
                this.$store.dispatch("storeUser", {
                    user: value
                });
            }
        }
    },
    methods: {
        send(e) {
            e.preventDefault();

            this.axios
                .post("/api/auth/login", {
                    email: this.email,
                    password: this.password,
                    remember_me: true
                })
                .then(response => {
                    localStorage.setItem("token", response.data.access_token);

                    this.axios.defaults.headers.common = {
                        Authorization: `Bearer ${response.data.access_token}`
                    };
                    this.$router.push("/conversations");
                })
                .catch(error => {
                    this.$router.push("/login");
                });
        }
    }
};
</script>

<style scoped lang="scss">
.inscription {
    margin-top: 60px;

    .logo {
        position: fixed;
        top: -50px;
        left: -65px;
        width: 80%;
        opacity: 0.3;
    }
    .contenu {
        margin: 0 34px;
        text-align: left;
    }

    .groupBouton {
        width: 100%;
        bottom: 40px;
    }
}
</style>